// @flow

export const ACCEPTED_FILE_TYPES = 'video/*';
export const MAX_FILE_SIZE = 5e8;
export const MAX_FILE_NUMBER = 1;
export const VIDEO_LIMIT_SECONDS = 300;
